import { StateToken } from '@ngxs/store';
import { CurrentRecordModel } from './current-record.state';

/**
 * Token referencing CurrentRecordState. It can be used to prevent circular dependencies caused by the import of
 * store states
 */
export const CURRENT_RECORD_STATE_TOKEN = new StateToken<CurrentRecordModel>('currentRecord');
